import {
   norcatAppColor,
   primaryColor500,
   primaryState50,
   primaryState500,
   primaryState800,
   FONT_FAMILY_REGULAR,
   FONT_FAMILY_MEDIUM,
   FONT_FAMILY_SEMI_BOLD,
   hoverBtnBgColor,
   isWeb,
   isHoverEnabled,
} from '../../utils/utils';

const {
   Image,
   Text,
   TouchableOpacity,
   View,
   StyleSheet,
   TextInput,
} = require('react-native');
import React from 'react';
/**
 *
 * @param {*} props
 * @returns
 */
const ErrorView = props => {
   const [isHover, setHover] = React.useState(false);
   const inputRef = React.useRef(null);

   React.useEffect(() => {
      if (isWeb && isHoverEnabled) {
         const INTV = setInterval(() => {
            if (inputRef.current) {
               inputRef?.current?.focus();
            }
         }, 1000);
         return () => clearInterval(INTV);
      }
   }, []);

   const icon =
      props.headerIcon === null || props.headerIcon === undefined
         ? require('../../assets/error_icon.png')
         : props.headerIcon;

   return (
      <View
         style={{
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'center',
         }}>
         {isWeb && (
            <TextInput
               ref={inputRef}
               style={{height: 0, width: 0}}
               autoFocus={isHoverEnabled} //For enter key event in web platform
               onKeyPress={event => {
                  if (event.nativeEvent.key === 'Enter') {
                     props.onRetry();
                  }
               }}
            />
         )}
         <View
            style={{
               flex: 1,
               justifyContent: 'flex-start',
               alignItems: 'center',
               marginBottom: 10,
            }}>
            <View style={styles.CircleShape}>
               <Image
                  source={icon}
                  style={{width: 100, height: 100, resizeMode: 'contain'}}
               />
            </View>
            <Text
               style={{
                  fontSize: 20,
                  color: primaryState800,
                  fontWeight: '600',
                  fontFamily: FONT_FAMILY_SEMI_BOLD,
               }}>
               {props.title}
            </Text>
            <Text
               style={{
                  fontSize: 12,
                  fontWeight: '500',
                  color: primaryState500,
                  marginTop: 8,
                  marginHorizontal: 10,
                  textAlign: 'center',
                  fontFamily: FONT_FAMILY_MEDIUM,
               }}>
               {props.message}
            </Text>
         </View>
         <View style={{width: '100%'}}>
            <TouchableOpacity
               style={{
                  backgroundColor: isHover ? hoverBtnBgColor : primaryColor500,
                  minHeight: 48,
                  borderRadius: 6,
                  justifyContent: 'center',
                  margin: 24,
               }}
               onMouseEnter={() => {
                  setHover(true);
               }}
               onMouseLeave={() => {
                  setHover(false);
               }}
               onPress={() => {
                  props.onRetry();
               }}>
               <Text
                  style={{
                     color: 'white',
                     fontSize: 16,
                     fontWeight: '500',
                     textAlign: 'center',
                     fontFamily: FONT_FAMILY_MEDIUM,
                  }}>
                  {props.buttonText}
               </Text>
            </TouchableOpacity>
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   CircleShape: {
      width: 100,
      height: 100,
      borderRadius: 100 / 2,
      backgroundColor: primaryState50,
      margin: 24,
   },
});
export default ErrorView;
